import React, { useMemo } from "react";
import { Box, Heading, HStack, Input, Field } from "@chakra-ui/react";
import { useAppStore } from "../../../context/store";

function clampNum(v, min, max) {
  const n = Number(v);
  if (!Number.isFinite(n)) return min;
  return Math.min(max, Math.max(min, n));
}

function SettingsMenuEditing() {
  const settings = useAppStore((s) => s.settings);
  const setSettings = useAppStore((s) => s.setSettings);

  const radius = useMemo(() => {
    const v = settings?.editing?.shiftSelectionRadius;
    return Number.isFinite(Number(v)) ? Number(v) : 3;
  }, [settings]);

  const onChangeRadius = (e) => {
    const raw = e.target.value;
    const next = raw === "" ? "" : clampNum(raw, 0.1, 1000);

    setSettings((prev) => ({
      ...prev,
      editing: {
        ...(prev?.editing || {}),
        shiftSelectionRadius: next === "" ? "" : next,
      },
    }));
  };

  const onBlurRadius = () => {
    const v = settings?.editing?.shiftSelectionRadius;
    const fixed = clampNum(v, 0.1, 1000);

    if (Number(v) !== fixed) {
      setSettings((prev) => ({
        ...prev,
        editing: {
          ...(prev?.editing || {}),
          shiftSelectionRadius: fixed,
        },
      }));
    }
  };

  return (
    <Box>
      <HStack gap={3} mb={3}>
        <Box p={1}>
          <Heading fontSize={"sm"} mb={2}>
            Shift Selection Radius (m)
          </Heading>

          <HStack gap={5}>
            <Field.Root width={"fit-content"}>
              <Input
                placeholder="Enter radius"
                type="number"
                min={0.1}
                step={0.1}
                value={radius}
                onChange={onChangeRadius}
                onBlur={onBlurRadius}
                width="180px"
              />
            </Field.Root>
          </HStack>
        </Box>
      </HStack>
    </Box>
  );
}

export default SettingsMenuEditing;
